var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.425 20.5a.875.875 0 01-.772-.452.956.956 0 01-.128-.438.816.816 0 01.127-.466l8.561-14.788A.897.897 0 0112 3.904a.897.897 0 01.787.452l8.56 14.788c.093.154.136.31.128.466a.955.955 0 01-.129.438.875.875 0 01-.771.452H3.425zM4.45 19h15.1L12 6 4.45 19zM12 17.808c.229 0 .42-.078.575-.232a.782.782 0 00.233-.576.782.782 0 00-.232-.576.782.782 0 00-.576-.232.782.782 0 00-.575.232.782.782 0 00-.233.576c0 .229.078.42.232.576a.782.782 0 00.576.232zm0-2.616c.213 0 .391-.072.534-.215a.726.726 0 00.216-.535v-3.5a.725.725 0 00-.216-.534.726.726 0 00-.534-.216.725.725 0 00-.534.216.725.725 0 00-.216.534v3.5c0 .213.072.39.216.535a.726.726 0 00.534.215z",
    fill: "currentColor"
  })));
}
SvgWarning.displayName = 'Warning';
export default SvgWarning;